import { render, staticRenderFns } from "./user-permissions.vue?vue&type=template&id=564dee68&scoped=true"
import script from "./user-permissions.vue?vue&type=script&lang=js"
export * from "./user-permissions.vue?vue&type=script&lang=js"
import style0 from "./user-permissions.vue?vue&type=style&index=0&id=564dee68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564dee68",
  null
  
)

export default component.exports